var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDropdown3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.60522 6.14992C3.60522 4.74445 4.74458 3.6051 6.15004 3.6051H9.96726C11.3727 3.6051 12.5121 4.74445 12.5121 6.14992V9.96714C12.5121 11.3726 11.3727 12.512 9.96726 12.512H6.15004C4.74458 12.512 3.60522 11.3726 3.60522 9.96714V6.14992Z",
    fill: "#3448FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.60522 17.6016C3.60522 16.1961 4.74458 15.0568 6.15004 15.0568H9.96726C11.3727 15.0568 12.5121 16.1961 12.5121 17.6016V21.4188C12.5121 22.8243 11.3727 23.9636 9.96726 23.9636H6.15004C4.74458 23.9636 3.60522 22.8243 3.60522 21.4188V17.6016Z",
    fill: "#3448FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0569 6.14992C15.0569 4.74445 16.1962 3.6051 17.6017 3.6051H21.4189C22.8244 3.6051 23.9637 4.74445 23.9637 6.14992V9.96714C23.9637 11.3726 22.8244 12.512 21.4189 12.512H17.6017C16.1962 12.512 15.0569 11.3726 15.0569 9.96714V6.14992Z",
    fill: "#3448FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0569 17.6016C15.0569 16.1961 16.1962 15.0568 17.6017 15.0568H22.6913C24.0968 15.0568 25.2361 16.1961 25.2361 17.6016V22.6912C25.2361 24.0967 24.0968 25.236 22.6913 25.236H17.6017C16.1962 25.236 15.0569 24.0967 15.0569 22.6912V17.6016Z",
    fill: "url(#paint0_linear_1668_2986)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1668_2986",
    x1: 14.4207,
    y1: 3.6051,
    x2: 14.4207,
    y2: 25.236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B86BEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D18BC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDropdown3);
export default __webpack_public_path__ + "static/media/icon-dropdown3.62d0933f2f6a04668e2417cfab84d8e4.svg";
export { ForwardRef as ReactComponent };